export default "__VITE_ASSET__1762887e__"